<template>

  <section class="mb-30 lg:mb-80">

    <div class="container">

      <h1 class="anchorTitle font-bold text-center text-xl lg:text-2xl mb-25 leading-24 lg:leading-28">Configurateur Open</h1>

      <ol class="stepper">

        <li class="step isPrevious">
           <a @click.prevent="$emit('switchToEtape1');taggage('configurateur_open', 'etapes_tunnel', 'etape_1', { tealium_event: 'select_content' })" href="javascript:void(0)">
            <span class="outerNbr"><span class="nbr">1</span></span>
            <span class="txt">Mobile</span>
          </a>
        </li>

        <li class="step isPrevious">
          <a @click.prevent="$emit('switchToEtape2');taggage('configurateur_open', 'etapes_tunnel', 'etape_2', { tealium_event: 'select_content' })" href="javascript:void(0)">
            <span class="outerNbr"><span class="nbr">2</span></span>
            <span class="txt">Forfait mobile</span>
          </a>
        </li>

        <li class="step isPrevious">
          <a @click.prevent="$emit('switchToEtape3');taggage('configurateur_open', 'etapes_tunnel', 'etape_3', { tealium_event: 'select_content' })" href="javascript:void(0)">
            <span class="outerNbr"><span class="nbr">3</span></span>
            <span class="txt">Connexion</span>
          </a>
        </li>

        <li class="step isPrevious">
          <a @click.prevent="$emit('switchToEtape4');taggage('configurateur_open', 'etapes_tunnel', 'etape_4', { tealium_event: 'select_content' })" href="javascript:void(0)">
            <span class="outerNbr"><span class="nbr">4</span></span>
            <span class="txt">Offre Internet</span>
          </a>
        </li>

        <li class="step isActive" aria-current="step">
          <a href="#">
            <span class="outerNbr"><span class="nbr"><span class="block w-14 lg:w-24 h-14 lg:h-24 c-green2"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 20"><path fill="currentColor" fill-rule="evenodd" d="m24.9063 3.3549-13.6551 15.75-.0004-.0002c-.391.4503-.9917.7391-1.6657.7391-.674 0-1.2747-.2888-1.6657-.7391l-.0004.0002-6.8275-7.875.0003-.0003C.7993 10.8926.6239 10.4654.6239 10c0-.5437.2388-1.0358.6249-1.3921l.8535-.7875c.386-.3563.9195-.5766 1.5087-.5766.5302 0 1.015.1789 1.3882.4743l.0003-.0004 4.1589 4.2511L21.781.6888l.0004.0003c.3815-.3303.8944-.5329 1.4588-.5329 1.1784 0 2.1337.8815 2.1337 1.9688 0 .4653-.1754.8926-.4679 1.2296l.0003.0003Z" clip-rule="evenodd"/></svg></span></span></span>
            <span class="txt">Terminé !</span>
          </a>
        </li>

      </ol>
    </div>

  </section>

  <section>
    <div class="container">
      <h2 class="font-bold text-xl text-center leading-24 mb-30" v-html="data_etape0.field_etape5_titre.replace(/<\/?(p)[^>]*>/gi, '')"></h2>

      <div class="mb-35">
        <p class="text-center">{{  data_etape0.field_etape5_sous_titre }}</p>
      </div>

      <div class="dflex justify-center mb-35">
        <a @click="taggage('recap_configurateur_open', 'prendre_rdv_pack_open', 'https://espace-client.orange.fr/rdv/creation', { tealium_event: 'select_content' });taggageRecap('', '', '', globalStore.tag)" class="btn btn--md btn--fill-dark w-full lg:max-w-280" href="https://espace-client.orange.fr/rdv/creation" target="_blank">Prendre RDV en boutique</a>
      </div>

      <div class="dflex justify-center text-center mb-30">
        <button @click.prevent="taggage('recap_configurateur_open', 'voir_detail_votre_pack_open', 'https://caraibe.orange.fr/packs-open-forfaits-mobile-et-internet', { tealium_event: 'select_content' })" id="poRecapToggle2" class="poRecapToggle text-bold text-sm leading-20 underline hover:no-underline pointer" type="button" aria-controls="poRecap" aria-expanded="false">Voir le détail de votre Pack Open</button>
      </div>
    </div>
  </section>

  <component :is="recapComponent" :parcours="parcours" :tag="tag" :data_etape0="data_etape0" :paragraphId="paragraphId" @switchToEtape1="$emit('switchToEtape1')" @switchToEtape2="$emit('switchToEtape2')" @switchToEtape3="$emit('switchToEtape3')" @switchToEtape4="$emit('switchToEtape4')" @switchToEtape5="$emit('switchToEtape5')"/>



</template>

<script setup>
import { ref } from 'vue';
import { onMounted, nextTick } from 'vue';
import Etape5Recap from './Etape5Recap.vue';
import { taggage, taggageRecap, resetTag } from '@/utils/taggage.js';
import { globalStore } from '@/utils/store.js';

globalStore.tag.tealium_event = "cart_add";

const props = defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  tag: Object
});

const error5 = ref({});

const emit = defineEmits(['switchToEtape1','switchToEtape2','switchToEtape3','switchToEtape4','switchToEtape5']);

const recapComponent = ref(null);
recapComponent.value = Etape5Recap;


onMounted(async () => {
  try {
    //console.log('Etape5Inner mounted');
    props.parcours.etape = 5;

    if (props.parcours.detail) {
      console.log('[Configurateur DEBUG] detail=true, attente de l\'event listener...');
      await nextTick();

      // Attendre que l'event listener soit attaché (data-listener-added="true")
      const waitForListener = setInterval(() => {
        const toggleButton = document.querySelector('.poRecapToggle[data-listener-added="true"]');
        console.log('[Configurateur DEBUG] Recherche du bouton...', toggleButton ? 'TROUVÉ' : 'pas trouvé');

        if (toggleButton) {
          clearInterval(waitForListener);
          console.log('[Configurateur DEBUG] Event listener trouvé, clic dans 50ms...');
          setTimeout(() => {
            toggleButton.click();
            console.log('[Configurateur] Récapitulatif ouvert automatiquement (detail=true)');
          }, 50);
        }
      }, 50);

      // Timeout après 3 secondes
      setTimeout(() => {
        console.log('[Configurateur DEBUG] Timeout après 3s');
        clearInterval(waitForListener);
      }, 3000);
    }
  } catch (e) {
    error5.value = e.message;
    console.error('[Configurateur DEBUG] Erreur:', e);
  }
});

</script>
